<template>
 <div class="page">
  <section class="content-section primary">
    <div class="section-title">
        <!-- <div class="section-title-line"></div> -->
        <h1>UNSERE WERKSTATT</h1>
        <!-- <div class="section-title-line"></div> -->
    </div>
    <div class="container">
      <article class="detailed-info">
        <p>Auf über 500 m² fertigen wir in unserer Werkstatt die verschiedensten Natursteinprodukte an. Ob Fräsen, Schleifen, Sägen oder Bohren, mithilfe modernster Technik sind wir in der Lage millimetergenau zu arbeiten und somit (fast) jeden Kundenwunsch zu erfüllen! Neben einer Kopierfräse, einem Kantenschleifautomaten und einer Brückensäge, setzen wir seit über 11 Jahren auch erfolgreich ein CNC-Bearbeitungszentrum ein. Mit diesem sind wir in der Lage Natursteine noch effizienter, präziser und flexibler zu bearbeiten und qualitativ hochwertige Endprodukte herzustellen.<br><br>Neben der Werkstatt - dem Herzstück auf unserem Betriebsgelände in Mönchengladbach – können Sie hier auch unsere Ausstellung <router-link :to="{ name: 'Kontakt' }">nach Terminvereinbarung</router-link> besuchen!</p>
        <hr>
       <div class="image-row">
            <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/IMG_9784_low.jpg"></div>
            <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/IMG_9800_low.jpg"></div>
            <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/IMG_9809_low.jpg"></div>
            <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/IMG_9812_low.jpg"></div>
            <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/IMG_9813_low.jpg"></div>
            <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/IMG_9833_low.jpg"></div>
        </div>
      </article>
      </div>
    </section>
    </div>
</template>

<script>
export default {
  name: 'UnsereWerkstatt',
  metaInfo: {
    title: 'Unsere Werkstatt',
    meta:[
      { vmid: 'description', name: 'description', content: "Quarzkomposit besteht meist aus über 90 Prozent Quarz das mit einem Kunstharz und Farbstoffen zu einem sehr widerstandsfähigem Material zusammengefügt wird."},
      { vmid: 'keywords', name: 'keywords', content: "Quarzkomposit, Silestone, Ceasarstone, Dekton, Naturstein, Natursteinhandel Mönchengladbach"},
      
    ],
    links: [ {rel: 'canonical', href: 'https://www.marmor-kunze.de/unsere-werkstatt'} ]
  },
 
}
</script>
j
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/UnsereWerkstatt.vue